<script>
  export let productHandle;
  const apiToken = window.settings.judge_me.public.apiToken;
  const domain = window.shop.permanent_domain;

  async function getRating() {
    try {
      return await fetch(`https://judge.me/api/v1/widgets/preview_badge?api_token=${apiToken}&shop_domain=${domain}&handle=${productHandle}`)
        .then(response => {
          if (response.ok) {
            return response;
          }

          throw `${response.status}: ${response.statusText} [${productHandle}]`;
        })
        .then(response => response.json())
        .then(response => response?.badge || null);
    } catch (error) {
      console.warn(error);

      return null;
    }
  }

  let rating = getRating();
</script>

{#await rating then widget}
  {#if widget}
    <div>
      <div class="text-[10px]">
        {@html widget}
      </div>
    </div>
  {/if}
{/await}
